<template>
    <div>
        <!--<button @click="test">ClickMe</button>-->
        <div class="overlay ModalOverlay" v-if="loading">
            <i class="fa fa-refresh fa-spin"></i>
        </div>
        <!--{{ allUsersSelected | json }}-->
        <dl v-for="(roleMember,role) in allUsersSelected">
            <dt>{{ role }}</dt>
            <dd v-for="user in roleMember">
                <div style="width:100%; display:inline-block">
                    <div class="selection-label">
                        <span class="selection-label_remove" role="presentation" @click="remove(user)">×</span>
                        {{ user.membre.fullName }}
                    </div>
                </div>
            </dd>
        </dl>
    </div>
</template>


<script type="text/babel">
    import {mapGetters, mapActions} from 'vuex'

    export default {
        computed: {
            //Map des getters de vuex
            ...mapGetters({
                allUsersSelected: 'getAllUsersSelected',
            }),
        },
        props: {
            users: {
                type: Array,
                default: function () {
                    return []
                },
                required: false
            },

            linkOnRemove: {
                type: String,
                required: false
            },
            idOther: Number,
            typeLink: String,
            sendAjax: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                msg: "",
                loading: false,
            }
        },
        ready: function () {
            if (this.users.length > 0) {
                this.users = this.users[0]
                for (var i = 0; i < this.users.length; i++) {
                    this.addToAllUserSelected(this.users[i].role, this.users[i].membre)
                }
            }
        },
        methods: {
            ...mapActions({
                removeFromAllUsersSelected: "removeFromAllUsersSelected",
                addToAllUserSelected: "addToAllUserSelected",
                sendSticky: "sendSticky"
            }),
            createPostData: function (user) {
                switch (this.typeLink.toLowerCase()) {
                    case 'compte':
                        this.postData = {
                            id_member: user.membre.id,
                            id_role: user.role.id,
                            id_compte: this.idOther
                        }
                        break;
                }
            },
            remove: function (user) {
                this.loading = true
                if (this.sendAjax) {
                    this.createPostData(user);
                    if (!this.$http)
                        return console.log('You need to install the `vue-resource` plugin')
                    if (!this.linkOnRemove)
                        return console.log('You need to set the linkOnRemove prop')

                    const linkOnRemove = this.linkOnRemove
                    this.$http.post(linkOnRemove, this.postData).then(function (response) {
                        let data = response.data
                        data = this.prepareResponseData ? this.prepareResponseData(data) : data
                        this.removeFromAllUsersSelected({role: user.role, user: user.membre})
                        this.loading = false
                        var n = noty({text: data, type: "success"});
                    }, (response) => {
                        this.loading = false
                        var n = noty({text: data, type: "error"});
                    })
                } else {
                    this.removeFromAllUsersSelected({role: user.role, user: user.membre})
                    this.loading = false
                }
            },
            mounted: function () {
                this.$nextTick(function () {
                    if ((this.linkOnRemove == "" || typeof (this.linkOnRemove) == "undefined") && this.sendAjax)
                        this.linkOnRemove = route('removeMemberToCompte');
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Operations/listOfMembersLink.vue